import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthLayout from '../components/Layout/AuthLayout';
import Layout from '../components/Layout/Layout/Layout';
import AdminLayout from '../components/Layout/AdminLayout/AdminLayout';
import Login from '../views/Auth/Login';
import Register from '../views/Auth/Register';
import Home from '../views/Home';
import Settings from '../views/Settings';
import Strategies from '../views/Strategies';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import Reports from '../views/Reports';
import ForgotPassword from '../views/Auth/ForgotPassword';
import ConfirmAccount from '../views/Auth/ConfirmAccount';
import ResetPassword from '../views/Auth/ResetPassword';
import RegisterRequest from '../views/Auth/RegisterRequest';
import AdminLogin from '../views/Auth/AdminLogin';
import AdminRoutes from './AdminRoutes';
import AdminDashBoardTable from '../views/Admin/AdminDashboard';
import UserData from '../views/Admin/UserData';
import Notes from '../views/Notes';
import AdminDocuments from '../views/Admin/AdminDocuments';
import VerifyAccount from '../views/Auth/VerifyAccount';
import AdminReports from '../views/Admin/AdminReports';
import { OnboardingIntroduction, Onboarding } from '../views/Auth/Onboarding';
import RegisterSuccess from '../views/Auth/Register/RegisterSuccess';
import Documents from '../views/Documents';
import Tasks from '../views/Tasks/Tasks';
import TaskDetails from '../views/TaskDetails/TaskDetails';
import AdminGeneral from '../views/Admin/AdminGeneral';
import { AdminManagers } from '../views/Admin/AdminManagers/AdminManagers';
import { RegisterMember } from '../views/Auth/Register/RegisterMember';

const Navigator = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<PublicRoutes />}>
          <Route path='/onboarding'>
            <Route index element={<Onboarding />} />
            <Route path='introduction' element={<OnboardingIntroduction />} />
          </Route>
          <Route path='/' element={<AuthLayout />}>
            <Route path='/' element={<Login />} />
            <Route path='/admin-login' element={<AdminLogin />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/register'>
              <Route index element={<Register />} />
              <Route path='success' element={<RegisterSuccess />} />
              <Route path='request' element={<RegisterRequest />} />
              <Route path='member' element={<RegisterMember />} />
            </Route>
            <Route path='/verify-account/:email' element={<VerifyAccount />} />
            <Route
              path='/confirm-account/:userId'
              element={<ConfirmAccount />}
            />
          </Route>
        </Route>
        <Route path='/' element={<AuthLayout />}>
          <Route path='/reset-password/:resetId' element={<ResetPassword />} />{' '}
        </Route>
        <Route path='/' element={<PrivateRoutes />}>
          <Route path='/' element={<Layout />}>
            <Route path='/home' element={<Home />} />
            <Route path='/strategies/:strategyId' element={<Strategies />} />
            <Route path='/reports' element={<Reports />} />
            <Route path='/notes' element={<Notes />} />
            <Route path='/settings' element={<Settings />} />
            <Route path='/documents' element={<Documents />} />
            <Route path='tasks'>
              <Route index element={<Tasks />} />
              <Route path=':taskId' element={<TaskDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path='/' element={<AdminRoutes />}>
          <Route path='/admin' element={<AdminLayout />}>
            <Route index element={<AdminDashBoardTable />} />
            <Route path='user/:userId'>
              <Route index element={<UserData />} />
              <Route path='documents' element={<AdminDocuments />} />
              <Route path='reports' element={<AdminReports />} />
              <Route path='general-information' element={<AdminGeneral />} />
            </Route>
            <Route path='managers' element={<AdminManagers />} />
          </Route>
        </Route>
        <Route path='/contact' element={<div>Contact</div>} />
      </Routes>
    </Router>
  );
};

export default Navigator;
